
import chMessages from '../locales/zh-HK';

const ChLang = {
    messages: {
        ...chMessages
    },
    locale: 'zh-HK',
   
};
export default ChLang;